import { Directive, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewContainerRef } from '@angular/core';
import { SearchPortalEntry, SearchPortalsRegistry } from '../services';

@Directive({
  standalone: false,
  selector: '[campusSearchPortal], [searchPortal]',
})
export class SearchPortalDirective implements OnInit, OnDestroy, OnChanges {
  @Input() searchPortal: string;

  private registry = inject(SearchPortalsRegistry);

  constructor(public viewContainerRef: ViewContainerRef) {}

  ngOnInit(): void {
    this.registry.register(this);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.searchPortal) return;
    const previous = changes.searchPortal.previousValue as string | undefined;
    if (previous && previous !== this.searchPortal) {
      const previousEntry: SearchPortalEntry = { searchPortal: previous, viewContainerRef: this.viewContainerRef };
      this.registry.unregister(previousEntry);
    }
    if (!changes.searchPortal.firstChange) {
      this.registry.register(this);
    }
  }

  ngOnDestroy(): void {
    this.registry.unregister(this);
  }
}
